import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyHotelSearchHead = loadable(() => import(/* webpackChunkName: "content/guest/hotel-search-head" */ './HotelSearchHead'), 'HotelSearchHead');
